// @flow

import styles from './SeoBlurb.less';

import React, { Component } from 'react';

import { ScreenReaderOnly, TextLink, Text } from 'seek-style-guide/react';
import NavLink from 'src/components/NavLink/NavLink';

type Props = {
  blurb: Array<Object | string>,
  locale: Locale,
  pathname: string,
  pageNumber: number
};

function renderLink(key, seg) {
  const { text, path: pathname, query, ...props } = seg;

  return (
    <NavLink
      component={TextLink}
      key={key}
      className={styles.link}
      aria-label={text}
      analytics="seo-blurb-click"
      location={{ pathname, query }}
      {...props}
    >
      {text}
    </NavLink>
  );
}

function renderBlurb(blurb) {
  const segments = blurb.map((seg, index) => {
    if (typeof seg === 'object') {
      return renderLink(index, seg);
    }
    return <span key={index}>{seg}</span>;
  });
  return <p>{segments}</p>;
}

export default class SeoBlurb extends Component<Props> {
  props: Props;

  render() {
    return (
      <div className={styles.content} data-automation="sub-classifications">
        <ScreenReaderOnly>
          <h2>Refine by sub-classifications</h2>
        </ScreenReaderOnly>
        <Text small>{renderBlurb(this.props.blurb)}</Text>
      </div>
    );
  }
}
